<template>
  <div>
    <div
      v-if="isLoaded && isAuthenticated"
      class="container marginLargeTop"
    >
      <div class="flexStart tabContainer">
        <span
          class="tab navLink"
          :class="{ currentTab: activeTab === 'tax-exemption' }"
          @click.self="tabClick('tax-exemption')"
        >Tax Exemption</span>
        <span
          class="tab navLink"
          :class="{ currentTab: activeTab === 'my-certificates' }"
          @click.self="tabClick('my-certificates')"
        >Certificates</span>
      </div>
      <div class="tabContent">
        <div v-if="activeTab === 'tax-exemption'">
          <CertCaptureFormComponent />
        </div>
        <div v-show="activeTab === 'my-certificates'">
          <div>
            <div class="certificates-list-container">
              <div class="flexBox flexEnd">
                <button
                  v-show="sortedCertificates.length > 0"
                  class="blue"
                  @click="addCertificateClick"
                >
                  Add a New Certificate
                </button>
              </div>
              <!-- If loading certificates -->
              <div
                v-show="loadingCertificates"
                class="loadingCertificates"
              >
                <div class="loading" />
              </div>
              <!-- If no certificates -->
              <div
                v-if="sortedCertificates.length === 0 && !loadingCertificates"
                class="textCenter no-certificates"
              >
                <div>
                  <p class="textCenter">
                    You have not uploaded any certificates.
                  </p>
                  <button
                    class="cancelButton blockButton borderlessButton"
                    @click="addCertificateClick"
                  >
                    Add a New Certificate
                  </button>
                </div>
              </div>
              <!-- List certificates -->
              <div v-if="sortedCertificates.length > 0 && !loadingCertificates">
                <CertificateListComponent
                  :certificates="certificates"
                  :delete-certificate="deleteCertificate"
                  :on-success="onCertSuccess"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isAuthenticated === false"
      class="container marginLargeTop"
      style="min-height: 500px"
    >
      <div class="textCenter marginLargeTop paddingLargeTop">
        <h3 class="marginExtraLargeTop">
          Unauthenticated
        </h3>
        <p class="marginTop">
          <a
            class="cursorPointer"
            @click="clickAccountMenu"
          >Sign in</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CertCaptureMixin from '../../mixins/CertCaptureMixin.js'
import CertificateListComponent from './CertificateListComponent.vue'
import CertCaptureFormComponent from './CertCaptureFormComponent.vue'

/**
 * The base CertCapture Component for CertCapture page.
 * @displayName CertCapture Page Container Component
 */
export default {
  name: 'CertCaptureComponent',
  components: {
    CertificateListComponent,
    CertCaptureFormComponent
  },
  mixins: [CertCaptureMixin],
  props: [],
  data () {
    return {
      GenCert: window.GenCert,
      activeTab: 'my-certificates',
      formValues: {
        state: ''
      },
      exposureZones: [],
      loadingExposureZones: false,
      certificates: [],
      loadingCertificates: false,
      loadingCertCapture: false,
      isAuthenticated: null,
      isLoaded: false
    }
  },
  computed: {
    /**
     * Computed value to sort our certificate list by expiration date[desc?]
     *
     * @public
     */
    sortedCertificates: function () {
      function compare (a, b) {
        if (a.expirationDate < b.expirationDate) return -1
        if (a.expirationDate > b.expirationDate) return 1
        return 0
      }
      return this.certificates.slice(0).sort(compare)
    },
    /**
     * "Are we authenticated?".
     *
     * @public
     */
    authenticated: function () {
      return this.$store.getters.isAuthenticated
    },
    /**
     * Returns the apiResponse authenticated value.
     *
     * @public
     */
    apiResponse: function () {
      return this.$store.getters.apiResponse.authenticate
    }
  },
  watch: {
    /**
     * Will upload local state after user authentication has completed.
     *
     * @public
     */
    apiResponse: function () {
      if (
        this.apiResponse.message_id === 'AUTHENTICATE_SUCCESS' &&
        this.isAuthenticated === null
      ) {
        this.isAuthenticated = true
        this.init()
      } else if (this.apiResponse.message_id === 'AUTHENTICATE_FAILED') {
        // We are not logged in, we cannot be here. Must sign in.
        this.isAuthenticated = false
      }
    }
  },
  /**
    * Gets called when this component has mounted.
    *
    * @public
    */
  mounted () {},
  methods: {
    /**
     * Gets called when Authenticated component completes authenticating user.
     *
     * @public
     */
    init: function () {
      this.isLoaded = true
      // We need certificates
      this.getCertificateList()
      // So we can open on Add Certiificate page
      if (window.location.hash === '#add-certificate') {
        this.activeTab = 'tax-exemption'
      }
    },
    /**
     * Gets called when user clicks Add Certificate button.
     *
     * @public
     */
    addCertificateClick: function () {
      this.activeTab = 'tax-exemption'
    },
    /**
     * Gets called when user has deleted a certificate.
     *
     * @public
     */
    deleteCertificate: function (id) {
      this.certificates = this.certificates.filter(value => {
        return value.id !== id
      })
    },
    /**
     * Gets called when user clicks the tabs.
     *
     * @public
     */
    tabClick: function (tab) {
      this.activeTab = tab
      if (tab === 'my-certificates') {
        this.getCertificateList()
      }
    },
    /**
     * Gets called when CertCaptureFormComponent receives success event on certificate creation.
     *
     * @public
     */
    onCertSuccess () {
      this.getCertificateList()
    },
    /**
     * Gets called when list of certificates needs fetched. Will call API to fetch
     * list from CertCapture.
     *
     * @public
     */
    getCertificateList () {
      this.loadingCertificates = true
      var apiPayload = {}
      apiPayload.apiEndpoint = 'customer'
      apiPayload.postData = {}
      apiPayload.postData.action = 'get_exemption_status'
      this.$store.dispatch('apiCall', apiPayload).then(response => {
        this.certificates = response.data.payload.response.certificates
        this.loadingCertificates = false
      })
    },
    /**
     * Gets called when user is not logged in. Will show login AccountCard,
     *
     * @public
     */
    clickAccountMenu () {
      let payload = {
        component: 'SignIn',
        props: []
      }
      // show the modal
      this.$store.dispatch('showModal', payload)
    }
  }
}
</script>

<style scoped></style>
